import { assignParams } from "../../core/utils";
import constants from "../../core/constants";
import isNil from "lodash/fp/isNil";
import omit from "lodash/fp/omit";
import conflictingDialogCtrl from "../conflictingDialog/conflictingDialog.controller";
import conflictingDialog from "../conflictingDialog/conflictingDialog.html";
class Controller {
  constructor(
    Events,
    $state,
    $stateParams,
    Messages,
    $injector,
    $location,
    $mdDialog,
    ResetFields,
    FillParams
  ) {
    "ngInject";
    this.Events = Events;
    this.$state = $state;
    this.Messages = Messages;
    this.$injector = $injector;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.ResetFields = ResetFields;
    this.$mdDialog = $mdDialog;
    this.CityHandler = $injector.get("CityHandler");
    this.isLoading = false;
    this.FillParams = FillParams;
  }

  getLimit() {
    return this.limit
      ? this.limit
      : this.$location.search().limit || constants.defaultLimit;
  }

  $onInit() {
    this.newItemModel = {};
    this.getInterceptor =
      this.getInterceptor ||
      (() => {
        return true;
      });

    this.Transforms = this.$injector.get(this.transformer);
    this.addOptions = this.addOptions || this.Transforms.addOptions;
    this.addItemResourceMethod = this.addItemResourceMethod || "post";
    this.fields = this.fields || this.Transforms.fields;
    this.filters = this.filters || this.Transforms.filters;
    this.selectedSort = this.$stateParams.sort;

    this.city = this.CityHandler.get();

    const errorEvent = this.Events.eventsType.onShowErrorNotification;
    const item = this.item || this.Transforms.item;
    const showSuccessNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const limit = this.getLimit();
    const page = this.$location.search().page || constants.defaultPage;

    let defaultOptions;
    if (isNil(this.city)) {
      defaultOptions = { page, limit };
    } else {
      const cityParam = this.city._id;
      defaultOptions = { page, limit, city: cityParam };
    }

    this.get = (params) => {
      const defaultParams = assignParams(
        omit("#")({ ...this.$stateParams }),
        defaultOptions
      );
      const usedParams = params ? omit("#")({ ...params }) : defaultParams;
      if (!isNil(this.resource) && this.$injector.has(this.resource)) {
        const resourceMethod = this.resourceMethod || "getAll";
        const resource = this.$injector.get(this.resource);
        const method = resource[resourceMethod].bind(
          this.$injector.get(this.resource)
        );

        const withDefaultParams = Object.assign(
          {},
          usedParams,
          this.resourceParams
        );
        const shouldGet = this.getInterceptor(withDefaultParams);
        if (shouldGet === true) {
          this.interceptorMsg = null;
          this.isLoading = true;
          method(withDefaultParams)
            .$promise.then(
              (response) => {
                const transformer = this.$injector.get(this.transformer);

                if (isNil(transformer[this.transformerMethod])) {
                  const transformerMethod = this.$injector.get(this.transformer)
                    .justify;
                  this.items = transformerMethod.bind(
                    transformer,
                    response.hits
                  )();
                } else {
                  const transformerMethod = transformer[this.transformerMethod];
                  this.items = transformerMethod.bind(
                    transformer,
                    response.hits
                  )();
                }
                response.type === "captain" ||
                response.type === "route" ||
                response.type === "company"
                  ? (this.total = 0)
                  : (this.total = response.total || response.count);
              },
              (response) =>
                this.Events.emit(errorEvent, response.data || response.message)
            )
            .finally(() => {
              this.isLoading = false;
            });
        } else {
          this.items = [];
          this.interceptorMsg = shouldGet;
          this.total = 0;
        }
      }
    };

    if (this.reUpdateEvent) this.Events.on(this.reUpdateEvent, this.get);

    const onEvent = (options) => {
      this.activeParams = { ...this.activeParams, ...options };
      const params = assignParams(
        omit("#")({ ...this.$stateParams }),
        this.activeParams
      );
      if (!isNil(options.page) && options.page !== this.page) {
        // If page number is passed through options it should be updated on the view
        this.page = options.page;
      }

      if (!this.forgetParams) this.$location.search(omit("#")(params));
      this.get(params);
    };

    this.showConflictDialog = (captainConflict, timezone) => {
      this.$mdDialog.show({
        controller: conflictingDialogCtrl,
        controllerAs: "$ctrl",
        template: conflictingDialog,
        locals: {
          captainConflict,
          timezone,
        },
      });
    };
    const onAdd = (options) => {
      if (this.addExtraParams) {
        options = Object.assign({}, options, this.addExtraParams);
      }
      this.$injector
        .get(this.resource)
        [this.addItemResourceMethod](options)
        .$promise.then(
          (response) => {
            const {
              id,
              _id: ID,
              data: { id: dataId = "", _id: dataID = "" } = {},
            } = response;

            if (this.shouldReupdate) {
              this.Events.emit(this.reUpdateEvent);
            }

            this.newItemModel = {};
            this.addOptions.fields = this.ResetFields.reset(
              this.addOptions.fields
            );
            this.Events.emit(
              showSuccessNotificationEvent,
              this.Messages.addMessage(item.title)
            );
            if (item.state) {
              this.$state.transitionTo(item.state, {
                id: id || ID || dataId || dataID,
              });
            }
          },
          (response) => {
            if (this.shouldResetOnError) {
              this.addOptions.fields = this.ResetFields.reset(
                this.addOptions.fields
              );
            }
            if (response.data.captainConflict) {
              const captainConflict = response.data.captainConflict;
              const timezone = this.addOptions.city.timezone;
              this.showConflictDialog(captainConflict, timezone);
            }
            this.Events.emit(errorEvent, response.data);
          }
        );
    };
    this.get();

    if (this.paginateEvent) this.Events.on(this.paginateEvent, onEvent);
    if (this.filterEvent) this.Events.on(this.filterEvent, onEvent);
    if (this.addItemEvent) this.Events.on(this.addItemEvent, onAdd);
    if (this.sortEvent) this.Events.on(this.sortEvent, onEvent);
  }

  $onDestroy() {
    if (this.reUpdateEvent) this.Events.off(this.reUpdateEvent, this.get);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/listView/listView.controller.js